import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Form, InputGroup, Container } from "react-bootstrap";
import ReporteCamion from "./ReporteCamion";
import API_BASE from "../api"; // ✅ Importamos la URL base

function ListaReportesCamion() {
  const [reportes, setReportes] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [reporteSeleccionado, setReporteSeleccionado] = useState(null);
  const reporteRef = useRef();

  useEffect(() => {
    fetch(`${API_BASE}/reportes-camion`) // ✅ Usamos la URL base aquí
      .then((res) => res.json())
      .then((data) => setReportes(data))
      .catch((err) => console.error("Error cargando reportes:", err));
  }, []);

  const eliminarReporte = async (id) => {
    if (window.confirm("¿Seguro que quieres eliminar este reporte?")) {
      try {
        await fetch(`${API_BASE}/reportes-camion/${id}`, {
          method: "DELETE",
        });
        setReportes((prev) => prev.filter((r) => r._id !== id));
        alert("✅ Reporte eliminado");
      } catch (error) {
        alert("❌ Error al eliminar");
      }
    }
  };

  const imprimir = () => {
    const printContents = reporteRef.current.innerHTML;
    const logoURL = `/movimonte-logo.png`; // Ruta del logo ajustada

    const contentWithFixedLogo = printContents.replace(
      /<img\s+src="[^"]*logo[^"]*"/i,
      `<img src="${logoURL}"`
    );

    const win = window.open("", "", "width=800,height=600");
    win.document.write(`
      <html>
        <head>
          <title>Reporte</title>
          <style>
            body { font-family: Arial; padding: 40px; }
            table { width: 100%; border-collapse: collapse; }
            td, th { border: 1px solid #000; padding: 6px; text-align: left; }
            h2, h4 { text-align: center; }
            .firma { text-align: center; margin-top: 60px; }
            .firma-box { width: 160px; height: 40px; border-bottom: 1px solid #000; margin: 0 auto 6px; }
            img { width: 100px; }
          </style>
        </head>
        <body>${contentWithFixedLogo}</body>
      </html>
    `);
    win.document.close();
    win.onload = () => win.print();
  };

  const reportesFiltrados = reportes.filter((r) =>
    (r.numero + r.maquina + r.patente + r.operador + r.jefeObra)
      .toLowerCase()
      .includes(busqueda.toLowerCase())
  );

  return (
    <Container style={{ padding: 20 }}>
      <h3 className="mb-4">📂 Listado de Reportes de Camión</h3>

      <InputGroup className="mb-3">
        <Form.Control
          placeholder="🔍 Buscar por número, máquina, patente..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </InputGroup>

      <Table bordered hover responsive>
        <thead>
          <tr>
            <th>Fecha</th>
            <th>Número</th>
            <th>Máquina</th>
            <th>Patente</th>
            <th>Operador</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {reportesFiltrados.map((r) => (
            <tr key={r._id}>
              <td>{`${r.fecha?.dia}/${r.fecha?.mes}/${r.fecha?.año}`}</td>
              <td>{r.numero}</td>
              <td>{r.maquina}</td>
              <td>{r.patente}</td>
              <td>{r.operador}</td>
              <td>
                <Button size="sm" onClick={() => setReporteSeleccionado(r)} variant="info" className="me-2">
                  👁️ Ver
                </Button>
                <Button size="sm" onClick={() => eliminarReporte(r._id)} variant="danger">
                  🗑️ Eliminar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {reporteSeleccionado && (
        <div className="mt-5">
          <div ref={reporteRef}>
            <ReporteCamion datos={reporteSeleccionado} />
          </div>
          <div className="d-flex gap-2 mt-2">
            <Button variant="secondary" onClick={() => setReporteSeleccionado(null)}>
              🔙 Cerrar
            </Button>
            <Button variant="success" onClick={imprimir}>
              🖨️ Imprimir / PDF
            </Button>
          </div>
        </div>
      )}
    </Container>
  );
}

export default ListaReportesCamion;
